import React from 'react';
// import { toast } from 'react-toastify';
import toast from '../../components/Toastify';

// start quill
import ReactQuill, { Quill } from 'react-quill';

var custTagDropDown = Quill.import('ui/picker');
custTagDropDown = [];
Quill.register(custTagDropDown, true);

const customHandlerDrpDown = {
  'custTagDropDown': function (value) {
    if (this.quill.getText().includes(value) != true)
      this.quill.insertText(this.quill.getSelection().index, '{{' + value + '}}', 'user');
    else
      toast.error('{{' + value + '}} alreary available');
  }
};

const toolbarModule = {
  container: [
    [{ 'custTagDropDown': [] }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }]
  ],
  handlers: customHandlerDrpDown
};

//for common module
const modulesQuill = {
  toolbar: toolbarModule
};

//for format quill
const formatsQuill = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'align',
  'link', 'image', 'background', 'color', 'emoji'
];
// end quill

const DataCollectCard = ({
  widgetById,
  handleWidgetChange,
  handleInputchange,
  frmdtintnm,
  createCustomCollectorReview,
  deleteCustomCollectorReview
}) => {
  //create dynemic value dropdown for editor
  let arrChips = [];
  if (widgetById.wdtnm == 'feedback') {
    arrChips = ['HOST_NAME', 'USER_INPUT', 'CITY', 'STATE', 'COUNTRY', 'PAGE_URL', 'DATE', 'IP_ADDRESS', 'LATITUDE', 'LONGITUDE'];
  } else {
    arrChips = ['USERNAME', 'EMAIL', 'PHONE', 'MESSAGE', 'CITY', 'STATE', 'DATE', 'COUNTRY', 'IP_ADDRESS', 'PAGE_URL', 'HOST_NAME', 'LATITUDE', 'LONGITUDE'];
  }
  toolbarModule.container[0][0].custTagDropDown = arrChips;
  var style = document.createElement('style');
  document.head.appendChild(style);
  for (let i = 0; i < arrChips.length; i++) {
    const e = arrChips[i];
    style.sheet.insertRule('.ql-picker-options span[data-value=' + e + ']::before {content: "{{' + e + '}}" !important;}');
    style.sheet.insertRule('.ql-picker-label[data-value=' + e + ']::before {content: "Dynamic Value" !important;}');
  }
  //end create dynemic value dropdown for editor
  return (
    <div className="tabs-layout-content">
      <div className="card card-editor card-template">
        <div className="card-editor-block p-0">
          <label className="card-editor-title">Send submitted data</label>
          <div className="customize-list">
            <div className="editor-field-list editor-toggle-fullwt">
              <div className=" editor-toggle customize-dropdown customize-showarrow width10x">
                <label className="label-title">Through Webhook</label>
                <label className="switch">
                  <input type="checkbox" checked={widgetById.ifrmdtsndwbh} onChange={(e) => handleWidgetChange('ifrmdtsndwbh', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
              {widgetById.ifrmdtsndwbh == true &&
                <div className="editor-input header-editor-ckeditor editor-header-title pb-0">
                  <div className="nf-group-input mb-0">
                    <label className="label-title">Webhook URL(where to send data)</label>
                    <input type="text"
                      className="editor-input-content editor-input-fullwidth"
                      value={widgetById.frmdtwbhurl}
                      onChange={(e) => handleWidgetChange('frmdtwbhurl', e.target.value)} />
                  </div>
                </div>
              }
            </div>
            <div className="editor-field-list editor-toggle-fullwt">
              <div className="editor-toggle customize-dropdown customize-showarrow width10x">
                <label className="label-title">Through Email</label>
                <label className="switch">
                  <input type="checkbox" checked={widgetById.ifrmdtsndeml} onChange={(e) => handleWidgetChange('ifrmdtsndeml', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
              {widgetById.ifrmdtsndeml == true &&
                <div className="">
                  <div className="editor-input header-editor-ckeditor editor-header-title ">
                    <label className="label-title">Email address(where to receive data)</label>
                    <input type="text" className="editor-input-content editor-input-fullwidth"
                      value={widgetById.frmdtsndemladd}
                      onChange={(e) => handleWidgetChange('frmdtsndemladd', e.target.value)} />
                  </div>
                  <div className="editor-input header-editor-ckeditor editor-header-title">
                    <label className="label-title">Email subject</label>
                    <input type="text" className="editor-input-content editor-input-fullwidth"
                      value={widgetById.frmdtsndemlsbjct}
                      onChange={(e) => handleWidgetChange('frmdtsndemlsbjct', e.target.value)} />
                  </div>
                  {widgetById.frmdtsndemltmplt &&
                    <div className="editor-input header-editor-ckeditor editor-header-title">
                      <label className="label-title">Email template</label>
                      <ReactQuill value={widgetById.frmdtsndemltmplt} modules={modulesQuill} formats={formatsQuill}
                        onChange={(newValue, delta, source) => {
                          if (source === 'user') {
                            handleWidgetChange('frmdtsndemltmplt', newValue);
                          }
                        }} />
                    </div>
                  }
                </div>
              }
            </div>
            <div className="editor-field-list editor-toggle-fullwt">
              <div className="editor-toggle customize-dropdown customize-showarrow width10x">
                <label className="label-title">Store in integration</label>
                <label className="switch">
                  <input type="checkbox" checked={widgetById.frmdtistrint} onChange={(e) => handleWidgetChange('frmdtistrint', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
              {widgetById.frmdtistrint == true &&
                <div>
                  {!widgetById.frmdtintnm ?
                    <div className="editor-input header-editor-ckeditor editor-header-title">
                      <div className="nf-group-input mb-0">
                        <label className="label-title">Integration name</label>
                        <input type="text"
                          className="editor-input-content editor-input-fullwidth"
                          value={frmdtintnm}
                          onChange={(e) => handleInputchange('frmdtintnm', e.target.value)} />
                      </div>
                      <div className="nf-group-input mb-0 mt-3 add-integra-btn text-center">
                        <input type="button"
                          className="nf-btn nf-btn-default"
                          value='Create'
                          onClick={createCustomCollectorReview} />
                      </div>
                    </div>
                    :
                    <div className="editor-input header-editor-ckeditor editor-header-title">
                      <div className="table-urladd-block">
                        <table className="table table-sm-font tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-include-url">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{widgetById.frmdtintnm}</td>
                              <td>
                                <span className="btn-action nf-btn btn-delete-light light-bg-icon btn-icon-20 tbl-action-dlt" onClick={deleteCustomCollectorReview}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                    <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                      <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                      <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                    </g>
                                  </svg>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataCollectCard;


// WEBPACK FOOTER //
// ./src/components/Widget/DataCollectCard.js